import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>
          スマホで左手デバイス<br></br>
          <br></br>
          プライバシーポリシー広告について
          本アプリでは、広告配信ツールとしてAdMob(Google
          Inc.)を使用しており、AdMobがご利用者の情報を自動取得する場合がございます。取得する情報、利用目的、第三者への提供等につきましては、以下の広告配信事業者のアプリケーション・プライバシーポリシーのリンクよりご確認ください。
          <a href="https://policies.google.com/technologies/ads?hl=ja利用状況解析ついて">
            Google 広告に関するポリシー
          </a>
          <br />
          <br />
          <a href="https://support.google.com/analytics/answer/6004245">
            Google データの保護
          </a>
          <br></br>
          <br></br>
          プライバシーポリシー
          <br></br>
          <br></br>
          福田恵一朗（以下、「本事業者」といいます。）は、個人データ又は通信の秘密に係る個人情報（以下、「個人データ等」といいます。）の取扱いについて、以下のとおりプライバシーポリシー（以下、「本ポリシー」といいます。）を定めます。
          <br></br>
          <br></br>
          1. 通知・公表又は同意取得の方法及び利用者関与の方法
          <br></br>
          <br></br>
          本ポリシーは、本ウェブサイトに掲載したことをもって公表したものとします。本事業者が取得する情報には、アプリケーション内でのユーザーの同意操作を受けて初めて取得するものが含まれます。本事業者によるこれらの情報の取得を停止するには、アプリケーションをアンインストールするか、アプリケーションに与えられた権限を変更してください。
          2. 第三者提供の有無
          <br></br>
          <br></br>
          本事業者は、本人の同意がある場合や個人情報保護法に規定される第三者提供制限の例外事由に該当する場合を除いて、第三者に個人データを提供することはありません。
          <br></br>
          <br></br>
          3. プライバシーポリシーの変更を行う場合の手続き
          <br></br>
          <br></br>
          4.
          本ポリシーの内容は、法令その他本ポリシーに別段の定めのある事項を除いて、ユーザーに通知することなく、本事業者により変更される場合があるものとします。
          5.
          本事業者が別途定める場合を除いて、変更後のプライバシーポリシーは、本ウェブサイトに掲載したときから効力を生じるものとします。
          <br></br>
          <br></br>
          お問い合わせは以下のメールアドレスもしくまでお願いします
          <br></br>
          Copyright 2024 keifukuda1115@gmail.com
        </p>
      </header>
    </div>
  );
}

export default App;
